import * as bootstrap from 'bootstrap'

// document.addEventListener("turbo:load", function(event) {
//   var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
//   var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
//     return new bootstrap.Popover(popoverTriggerEl)
//   })

//   var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
//   var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
//     return new bootstrap.Tooltip(tooltipTriggerEl)
//   })

//   const featherIconsInit = () => {
//     if (window.feather) {
//       window.feather.replace({
//         width: '16px',
//         height: '16px'
//       });
//     }
//   };
  
// })


['turbo:load','element_inserted','turbo:frame-load'].forEach(function(e) {
  document.addEventListener(e, function(event) {
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
      return new bootstrap.Popover(popoverTriggerEl)
    })
  
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl)
    })
  
    const featherIconsInit = () => {
      if (window.feather) {
        window.feather.replace({
          width: '16px',
          height: '16px'
        });
      }
    };
    
  })

});